import invariant from 'tiny-invariant';
import BaseProvider from './base-provider';

function track(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}

class GoogleTagManagerProvider extends BaseProvider {
    #skipInitialization = false;
    #id = null;
    #auth = null;
    #preview = null;
    #cookiesWin = null;

    constructor({ id, auth, preview, cookiesWin, skipInitialization = false } = {}) {
        invariant(skipInitialization || id, 'Google Tag Manager ID is required');

        super();
        this.#id = id;
        this.#auth = auth;
        this.#preview = preview;
        this.#cookiesWin = cookiesWin;
        this.#skipInitialization = skipInitialization;
    }

    async initialize() {
        if (this.#skipInitialization) return;

        // push gtm start event
        track({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
        });

        // create script src
        const url = new URL('https://www.googletagmanager.com/gtm.js');
        url.searchParams.set('id', this.#id);
        this.#auth && url.searchParams.set('gtm_auth', this.#auth);
        this.#preview && url.searchParams.set('gtm_preview', this.#preview);
        this.#cookiesWin && url.searchParams.set('gtm_cookies_win', this.#cookiesWin);

        // create script element
        const script = document.createElement('script');
        script.async = true;
        script.src = url.toString();
        document.getElementsByTagName('script')[0].appendChild(script);
    }

    async trackPageView() {
        track({
            event: 'pageview',
            page_location: window.location.href,
            page_title: document.title,
        });
    }

    async trackEvent(eventName, eventParam) {
        track({
            event: eventName,
            ...eventParam,
        });
    }

    async setUserId(userId) {
        track({
            event: 'setUserId',
            userId,
        });
    }

    async setEmail(email) {
        track({
            event: 'setEmail',
            email,
        });
    }

    async setUserProperties(properties) {
        track({
            event: 'setUserProperties',
            ...properties,
        });
    }
}

export default GoogleTagManagerProvider;
